/* @ngInject */

export default ($filter, $timeout, LIST) => {
  const List = () => {
    let model = angular.copy(LIST);

    /**
     * Clear list service.
     */
    const clear = () => {
      model = angular.copy(LIST);
    };

    /**
     * Deselected item(s).
     *
     * @param {Object|Object[]} object
     * @param {Boolean} [value]
     *
     * @returns {Boolean}
     */
    const deselectedData = (obj) => {
      const object = obj;
      for (let o = 0; o < object.length; o += 1) {
        object[o].isSelected = false;
      }
      return object.isSelected;
    };

    /**
     * Get data count.
     *
     * @returns {Number}
     */
    const getCount = () => model.data.length;

    /**
     * Get data.
     *
     * @returns {Object[]}
     */
    const getData = () => model.data;

    /**
     * Get set first letter grouping.
     *
     * @returns {String} - Grouping.
     */
    const getGroupingByFirstLetter = () => model.grouping.startingLetter;

    /**
     * Get first letter available groupings.
     *
     * @returns {Array} - Groupings.
     */
    const getGroupingByFirstLetters = () => model.grouping.startingLetters;

    /**
     * Get order direction of the list.
     *
     * @returns {Boolean} - Order direction.
     */
    const getOrder = () => model.ordering.isReversed;

    /**
     * Get order property of the list.
     *
     * @returns {String} - Property name.
     */
    const getOrderBy = () => model.ordering.property;

    /**
     * Get order class for the list. Class is generated based on the direction and property.
     *
     * @param {String} property - Name of the property.
     *
     * @returns {String} - Class.
     */
    const getOrderClass = (property) => {
      let output = model.ordering.isReversed ? 'reversed' : '';
      output += model.ordering.property === property ? ' active' : '';
      return output;
    };

    /**
     * Get shown limit of records in the list.
     *
     * @returns {Number} - Number of items.
     */
    const getRecordsShown = () => model.records.shown;

    /**
     * Get selected records.
     *
     * @returns {Object[]}
     */
    const getSelected = () => _.filter(model.data, { isSelected: true });

    /**
     * Get number of selected records.
     *
     * @returns {Number}
     */
    const getSelectedCount = () => getSelected().length;

    /**
     * Initialize grouping by the first letter.
     *
     * @param {Object[]} collection
     */
    const initGroupingByFirstLetter = (collection) => {
      const startingLetters = collection.map((item) => {
        if (item.docType === 'product') {
          return item?.getLenderName()?.charAt(0)?.toUpperCase();
        }
        return item?.getName()?.charAt(0)?.toUpperCase();
      });
      model.grouping.startingLetters = [...new Set(startingLetters)];
      model.grouping.startingLetters.sort();
      model.grouping.startingLetters.unshift('ALL');
    };

    /**
     * Set list records limit.
     */
    const incRecordsShown = () => {
      model.records.shown += model.records.limit;
    };

    /**
     * Is list grouped by given first letter?
     *
     * @param {String} letter - Letter.
     *
     * @returns {Boolean}
     */
    const isGroupingByFirstLetter = (letter) => model.grouping.startingLetter === letter;

    /**
     * Is collection showing all records?
     *
     * @returns {Boolean}
     */
    const isRecordsShownAll = () => {
      if (!model || !model.data || !model.data.length) {
        return true;
      }
      return model.data.length <= model.records.shown;
    };

    /**
     * Is anything in list selected?
     *
     * @returns {Boolean}
     */
    const isSelectedAny = () => _.some(model.data, (item) => item.isSelected === true);

    /**
     * Is everything in list selected?
     *
     * @returns {Boolean}
     */
    const isSelectedAll = () => _.every(model.data, (item) => item.isSelected === true);

    /**
     * Remove data.
     *
     * @param {Object|Object[]} object - Object to remove from collection.
     */
    const removeData = (object) => {
      if (object instanceof Array) {
        for (let o = 0; o < object.length; o += 1) {
          removeData(object[o]);
        }
      } else {
        model.data.splice(model.data.indexOf(object), 1);
      }
    };

    /**
     * Set data.
     *
     * @param {Object[]} collection
     */
    const setData = (collection) => {
      model.records.shown = model.records.limit;
      model.data = collection;
    };

    /**
     * Append data.
     *
     * @param {Object|Object[]} object
     */
    const setDataAppend = (object) => {
      if (object instanceof Array) {
        model.data = model.data.concat(object);
      } else {
        model.data.push(object);
      }
    };

    /**
     * Replace data.
     *
     * @param {Object} object
     * @param {String} key
     */
    const setDataReplace = (object, key) => {
      const k = key || 'id';
      const index = _.findIndex(model.data, (obj) => obj[k] === object[k]);
      $timeout(() => {
        model.data.splice(index, 1);
        $timeout(() => {
          model.data.push(object);
        });
      });
    };

    /**
     * Set grouping first letter.
     *
     * @param {String} letter - Letter.
     */
    const setGroupingByFirstLetter = (letter) => {
      model.grouping.startingLetter = letter;
    };

    /**
     * Set order by property.
     *
     * @param {String} property
     */
    const setOrderBy = (property) => {
      if (model.ordering.property === property) {
        model.ordering.isReversed = !model.ordering.isReversed;
      } else {
        model.ordering.property = property;
        model.ordering.isReversed = false;
      }
    };

    /**
     * Set selected item(s).
     *
     * @param {Object|Object[]} object
     * @param {Boolean} [value]
     *
     * @returns {Boolean}
     */
    const setSelected = (obj, value) => {
      const object = obj;
      if (object instanceof Array) {
        const val = !isSelectedAny();
        for (let o = 0; o < object.length; o += 1) {
          setSelected(object[o], val);
        }
        return val;
      }
      if (value !== undefined) {
        object.isSelected = value;
      } else {
        object.isSelected = !object.isSelected ? true : !object.isSelected;
      }
      return object.isSelected;
    };

    /**
     * Display number of selected item.
     *
     * @param {Object} params
     * @param {Array} params.items
     */
    const numberOfSelected = (params) =>
      $filter('filter')(params.items, { isSelected: true }).length;

    return {
      model,
      clear,
      deselectedData,
      getCount,
      getData,
      getGroupingByFirstLetter,
      getGroupingByFirstLetters,
      getOrder,
      getOrderBy,
      getOrderClass,
      getRecordsShown,
      getSelected,
      getSelectedCount,
      initGroupingByFirstLetter,
      incRecordsShown,
      isGroupingByFirstLetter,
      isRecordsShownAll,
      isSelectedAny,
      isSelectedAll,
      numberOfSelected,
      removeData,
      setData,
      setDataAppend,
      setDataReplace,
      setGroupingByFirstLetter,
      setOrderBy,
      setSelected
    };
  };

  return {
    List
  };
};
